import React from 'react';
import { Link } from 'react-router-dom'

export default function Mrlovekumar(){
	
			const style = {
  fontFamily: 'revert',
  fontSize: '15px',
  color: '#000',
  fontWeight: 'bolder'
};

  return (
     <div>
     {/* Header Start */}
	  <div className="container-fluid hero-header bg-light py5 mb-5"  style={{"padding-top":"1rem !important","padding-bottom":"1rem !important"}}>
		<div className="container py-5">
		  <div className="row g-5 align-items-center">
			<div className="col-lg-6">
			  <h1 className="display-4 mb3 animated slideInDown">Profile</h1>
			  <nav aria-label="breadcrumb animated slideInDown">
				<ol className="breadcrumb mb-0">
				  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
				  <li className="breadcrumb-item active" aria-current="page">Profile</li>
				</ol>
			  </nav>
			</div>
			
			
		  </div>
		</div>
	  </div>
	  {/* Header End */}
	  {/* About Start */}
	  <div className="container-xxl">
		<div className="container">
		  <div className="row g-5 align-items-center">
			<div className="vission-text">
					<h1 className="display-6">Mr.Hemant (Independent Director)</h1>
					<p style={{ textAlign: 'justify', color: 'black' }}>Mr. Hemant is a seasoned finance professional with over 6 years of experience in taxation, compliance, and financial management. As the Director of Finance & Compliance at Virtual CEO Advisory Pvt. Ltd., he plays a vital role in overseeing income tax, GST, payroll, and corporate financial reporting for a diverse range of clients, including corporates, Section 8 companies, and individuals.</p>
					<p style={{ textAlign: 'justify', color: 'black' }}>He specializes in income tax filings, TDS/TCS return preparation, GST registration and reconciliation (GSTR-1, GSTR-3B, GSTR-9 & 9C), and audit assistance. Mr. Hemant is also proficient in cash flow analysis, MIS reporting, and payroll processing, managing compliance for companies with workforces of over 700 employees.</p>
					<p style={{ textAlign: 'justify', color: 'black' }}>Prior to this, he served as an Accounts Executive at Anil K Goyal & Associates, where he built a solid foundation in both direct and indirect taxation.</p>
					<p style={{ textAlign: 'justify', color: 'black' }}>Mr. Hemant holds an MBA in Finance from IMT University and a Bachelor of Commerce degree from Delhi University.</p>

					<h2 style={{ fontFamily: 'revert', fontSize: '15px', color: '#000', fontWeight: 'bolder' }}>
					He has Directorship in the following Companies:
				  </h2>
				  <table style={style} className="table table-bordered table-striped">
					<thead>
					  <tr>
						<th width="20" className="text-center">Sr.no</th>
						<th className="text-left">Name of company</th>
						<th>Designation</th>
					  </tr>
					</thead>
					<tbody>
					  <tr>
						<td className="text-center">1</td>
						<td>KALPA COMMERCIAL LIMITED</td>
						<td width="280" className="text-center">Independent Director</td>
					  </tr>
					</tbody>
				  </table>

		</div>
		
		  </div>
		</div>
	  </div>
	  {/* About End */}
	</div>
    );
}